$(document).ready(function() {
  const KL_ZONE = "Asia/Kuala_Lumpur";
  var DateTime = luxon.DateTime;
  
  // Always get "Now" in Malaysia Timezone
  var today_date = DateTime.now().setZone(KL_ZONE);
  
  var cutoff_time = localStorage.getItem('collection_cutOff');
  var cart_collection = localStorage.getItem('cart_collection_list');

  var global_cutoff_str = $('[data-global-collection-cutoff]').text().trim();
  var disable_dates = ($('[data-disable-dates]').text() || "").split(",").map(v => v.trim()).filter(v => v !== "");

  // API Refresh Logic
  $('body').on('click', '[action="next_step"]', async function(){ 
    await $.ajax({
      url: '/collections/cny-2022?view=inajax-collect-metafields',
      method: 'get'
    })
    .done((res) => {
      localStorage.removeItem('collection_cutOff');
      localStorage.removeItem('cart_collection_list');
      
      let data = JSON.parse(res);
      cutoff_time = data["cutoff_time"];
      cart_collection = data["collections"];

      if(cutoff_time.length > 0) cutoff_time = cutoff_time[0].split(',');

      localStorage.setItem('cart_collection_list', JSON.stringify(cart_collection));
      localStorage.setItem('collection_cutOff', JSON.stringify(cutoff_time));
    });
    
    $(this).addClass('d-none');
    $(this).parents('.cart_mini_action_btns').find('[action="submit_cart_form"]').removeClass('d-none');
    $(this).parents('.widget_shopping_cart').find('.cart_item_content').addClass('d-none');
    $(this).parents('.widget_shopping_cart').find('.catr_mini_delivery ').removeClass('d-none');
    $(this).parents('.jas-mini-cart').find('.back_arrow ').removeClass('d-none');
  });

  $('body').on('click', '.jas-mini-cart .back_arrow', function(){ 
    $(this).parents('.jas-mini-cart').find('.cart_item_content').removeClass('d-none');
    $(this).parents('.jas-mini-cart').find('.catr_mini_delivery ').addClass('d-none');
    $(this).parents('.jas-mini-cart').find('[action="submit_cart_form"]').addClass('d-none')
    $(this).parents('.jas-mini-cart').find('[action="next_step"]').removeClass('d-none')
    $(this).addClass('d-none');

    $(".flatpickr-calendar.inline").hide()
  });

  function getDisabledDates() {
    var cutoff_dates = [];
    var global_cutoff_time_kl = DateTime.fromFormat(global_cutoff_str, 'HH:mm', { zone: KL_ZONE });

    // 1. Check Global Cutoff
    if(today_date.hour >= global_cutoff_time_kl.hour){
        cutoff_dates.push(today_date.toFormat('dd-MM-yyyy'));
    }

    // 2. Collection specific cutoffs
    let current_cutoff_obj = typeof cutoff_time === 'string' ? JSON.parse(cutoff_time) : cutoff_time;
    let current_cart_coll = typeof cart_collection === 'string' ? JSON.parse(cart_collection) : cart_collection;

    if(current_cutoff_obj && current_cart_coll){
        Object.values(current_cart_coll).forEach(collections => {
            Object.keys(current_cutoff_obj).forEach(collName => {
                if(Object.values(collections).includes(collName)){
                    let specific_times = current_cutoff_obj[collName]?.split(",").map(v => v.trim()).filter(v => v !== "") || [];

                    specific_times.forEach(timeStr => {
                        let cutoff_ts = DateTime.fromFormat(timeStr, 'dd-MM-yyyy HH:mm', { zone: KL_ZONE });

                        if(cutoff_ts.toFormat('HH:mm') === '00:00' || (cutoff_ts.toFormat('dd-MM-yyyy') === today_date.toFormat('dd-MM-yyyy') && today_date.hour >= cutoff_ts.hour)){
                            cutoff_dates.push(cutoff_ts.toFormat('dd-MM-yyyy'));
                        }

                        if(disable_dates.includes(cutoff_ts.toFormat('dd-MM-yyyy')) && cutoff_ts.toFormat('HH:mm') !== '00:00'){
                          disable_dates = disable_dates.filter(date => date !== cutoff_ts.toFormat('dd-MM-yyyy'));
                        }
                    });
                }
            });
        });
    }

    return [...new Set(disable_dates.concat(cutoff_dates))];
  }

  /**
   * Flatpickr Initialization with Timezone Safety
   * if disable date includes collection specific cutoff, then allow user to select date.
   */
  $('body').on('click', '.order__dates-item-day', function(){
    disable_dates = getDisabledDates();

    $(this).flatpickr({
      inline: true,
      minDate: today_date.toJSDate(),
      dateFormat: "d-m-Y",
      disable: disable_dates,
      onChange: function(selectedDates, dateStr) {
        $('#delivery-date-text, .delivery-date-texta').text(dateStr);
        $('[data-date-saver]').val(dateStr);
        $(".flatpickr-calendar.inline").hide();
        $(".flatpickr-calendar.inline").parents('.order__dates-col').addClass('active');
        $("[data-error-msg]").hide();
      }
    })

    $(".flatpickr-calendar.inline").show()
  });

  function validateDeliveryDate(formElement) {
    var date_selected = $(".calendar-box [data-date-selected]").text().trim();
    if (!date_selected) {
      $('.order__dates-item.calendar-box').addClass('activeAdd');
      return false;
    };

    disable_dates = getDisabledDates();

    if (disable_dates.includes(date_selected)) {
      $("[data-error-msg]").show();
      $('.order__dates-item.calendar-box').addClass('activeAdd');
      return false;
    }
    return true;
  }

  // handle checkout button
  $('body').on('click', '[action="submit_cart_form"]', function(){
    $(this).parents('.widget_shopping_cart').find('#cart_main_form').trigger('submit')
  });

  // Submit Handler
  $('body').on('submit', '#cart_main_form', function(e){
    e.preventDefault();
    // $('[data-error-agree-msg]').hide()
    
    // let checkBoxInput = document.getElementById('page_agree').checked;
    // if(!checkBoxInput) {
    //   $('[data-error-agree-msg]').show();
    //   return ;
    // }

    if(validateDeliveryDate(this)){
        $.ajax({
            type: 'POST', 
            url: '/cart',
            data: $(this).serialize(),
            success: () => { window.location.href = '/checkout'; }
        });
    }
  });

  // Checkout Button Handler (deprecated)
  // $('body').on('click', '[name="checkout"]', function(e) {
  //   e.preventDefault();
  //   let checkBoxInput = document.getElementById('page_agree').checked;
  //   if(!checkBoxInput) return;
    
  //   if(validateDeliveryDate(this)){
  //       $(this).parents('form').trigger('submit');
  //   }
  // });

  // sample card mesg
  $('body').on('change', '#occ[data-occasion]', function(){
    $(this).parents('.date-time-msg').find('[name="attributes[Message:]"]').val( $(this).val() ); 
    $(this).parents('.date-time-msg').find('[name="attributes[Topic:]"]').val($(this).find('[value="'+$(this).val()+'"]').text());
  });
  
    $('body').on('keyup', '.Cart__Note[name="attributes[Message:]"]', function(){
    $(this).parents('.date-time-msg').find('[name="attributes[Message:]"]').val($(this).val());

  });
  
  $('body').on('change', '[name="attributes[Delivery Time:]"]', function(){
    $('.order__session-col').removeClass('active')
    $(this).parents('.order__session-col').addClass('active')
    
  });
});